import React from 'react'; // do not remove this import
import { createSvgIcon } from '@mui/material/utils';

import pen from '@mui/icons-material/ModeEdit';
import editOutlined from '@mui/icons-material/EditOutlined';
import save from '@mui/icons-material/Save';
import send from '@mui/icons-material/Send';
import filledTrashcan from '@mui/icons-material/Delete';
import arrowUp from '@mui/icons-material/KeyboardArrowUpRounded';
import arrowRight from '@mui/icons-material/ArrowForwardIosRounded';
import arrowRightOutlined from '@mui/icons-material/ArrowRightOutlined';
import arrowLeftOutlined from '@mui/icons-material/ArrowLeftOutlined';
import arrowLeft from '@mui/icons-material/ArrowBackIosRounded';
import arrowDown from '@mui/icons-material/KeyboardArrowDownRounded';
import menu from '@mui/icons-material/Menu';
import undo from '@mui/icons-material/Undo';
import refresh from '@mui/icons-material/Refresh';
import verticalDots from '@mui/icons-material/MoreVert';
import filterList from '@mui/icons-material/FilterList';
import search from '@mui/icons-material/Search';
import print from '@mui/icons-material/PrintRounded';
import copy from '@mui/icons-material/ContentCopyRounded';
import cancel from '@mui/icons-material/DoNotDisturbAltRounded';
import cancelOutlined from '@mui/icons-material/CancelOutlined';
import uploadFile from '@mui/icons-material/UploadFile';
import attachEmail from '@mui/icons-material/AttachEmailRounded';
import close from '@mui/icons-material/Close';
import add from '@mui/icons-material/Add';
import remove from '@mui/icons-material/Remove';
import play from '@mui/icons-material/PlayCircleOutlineRounded';
import validate from '@mui/icons-material/DoneOutlineRounded';
import openNewTab from '@mui/icons-material/OpenInNewRounded';
import door from '@mui/icons-material/ExitToAppRounded';
import moreTime from '@mui/icons-material/MoreTimeRounded';
import removeFilter from '@mui/icons-material/FilterListOffRounded';
import toggleOn from '@mui/icons-material/ToggleOnRounded';
import tableChart from '@mui/icons-material/TableChartOutlined';
import timeline from '@mui/icons-material/DynamicFeedOutlined';
import reload from '@mui/icons-material/ChangeCircleOutlined';
import choices from '@mui/icons-material/AltRouteOutlined';
import block from '@mui/icons-material/Block';
import globe from '@mui/icons-material/Language';
import warningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import filterAltOffOutlined  from '@mui/icons-material/FilterAltOffOutlined';
import filterAltOutlined from '@mui/icons-material/FilterAltOutlined';
import addBoxIcon from '@mui/icons-material/AddBoxOutlined';
import postAddIcon from '@mui/icons-material/PostAddOutlined';

const arrowBack = createSvgIcon(
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7314_120402)">
      <path d="M23.25 12.3875L0.75 12.3875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.25 1.88745L0.75 12.3875L11.25 22.8875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_7314_120402">
        <rect width="24" height="24" fill="white" transform="translate(24 0.387451) rotate(90)" />
      </clipPath>
    </defs>
  </svg>,
  'arrowBack',
);

const arrowBackFat = createSvgIcon(
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7314_120402)">
      <path d="M23.25 12.3875L0.75 12.3875" stroke="#212121" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.25 1.88745L0.75 12.3875L11.25 22.8875" stroke="#212121" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_7314_120402">
        <rect width="24" height="24" fill="white" transform="translate(24 0.387451) rotate(90)" />
      </clipPath>
    </defs>
  </svg>,
  'arrowBackFat',
);

const arrowForward = createSvgIcon(
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7314_120402)">
      <path d="M0.75 12.3875L23.25 12.3875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.75 1.88745L23.25 12.3875L12.75 22.8875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_7314_120402">
        <rect width="24" height="24" fill="white" transform="translate(0 0.387451)" />
      </clipPath>
    </defs>
  </svg>,
  'arrowForward',
);

const trashcan = createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6875 12.9375V7.3125M7.3125 12.9375V7.3125M1.125 3.375H16.875M14.1487 15.843C14.1254 16.1243 13.9972 16.3866 13.7895 16.5778C13.5818 16.7689 13.3098 16.875 13.0275 16.875H4.97325C4.69096 16.875 4.41898 16.7689 4.21128 16.5778C4.00358 16.3866 3.87534 16.1243 3.852 15.843L2.8125 3.375H15.1875L14.1487 15.843ZM10.6875 1.125H7.3125C7.01413 1.125 6.72798 1.24353 6.517 1.4545C6.30603 1.66548 6.1875 1.95163 6.1875 2.25V3.375H11.8125V2.25C11.8125 1.95163 11.694 1.66548 11.483 1.4545C11.272 1.24353 10.9859 1.125 10.6875 1.125Z" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'trashcan',
);

const mail = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6756_118003)">
      <path d="M17.25 12C17.25 13.0384 16.9421 14.0534 16.3652 14.9167C15.7883 15.7801 14.9684 16.453 14.0091 16.8504C13.0498 17.2477 11.9942 17.3517 10.9758 17.1491C9.95738 16.9465 9.02192 16.4465 8.28769 15.7123C7.55347 14.9781 7.05345 14.0426 6.85088 13.0242C6.64831 12.0058 6.75227 10.9502 7.14963 9.99091C7.54699 9.0316 8.2199 8.21166 9.08326 7.63478C9.94662 7.05791 10.9617 6.75 12 6.75C13.3924 6.75 14.7277 7.30312 15.7123 8.28769C16.6969 9.27226 17.25 10.6076 17.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.25 12V14.25C17.25 15.0456 17.566 15.8087 18.1286 16.3713C18.6913 16.9339 19.4543 17.25 20.25 17.25C21.0456 17.25 21.8087 16.9339 22.3713 16.3713C22.9339 15.8087 23.25 15.0456 23.25 14.25V12C23.2499 9.46596 22.3942 7.00621 20.8215 5.01924C19.2489 3.03227 17.0515 1.63448 14.5852 1.05234C12.119 0.470197 9.52842 0.737804 7.23326 1.8118C4.93811 2.8858 3.0728 4.70328 1.93956 6.96977C0.806309 9.23626 0.471513 11.819 0.989408 14.2995C1.5073 16.78 2.84755 19.013 4.79301 20.6368C6.73846 22.2605 9.17516 23.1797 11.7083 23.2457C14.2415 23.3116 16.7227 22.5203 18.75 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6756_118003">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>,
  'mail',
);

// const door = createSvgIcon(
//   <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M6 9.00269H16.5" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     <path d="M14 11.5027L16.5 9.00269L14 6.50269" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//     <path d="M11.5 12V15C11.5114 15.253 11.4222 15.5003 11.2518 15.6877C11.0814 15.8751 10.8437 15.9874 10.5907 16H2.4087C2.15583 15.9872 1.91831 15.8749 1.74804 15.6875C1.57777 15.5001 1.48861 15.2529 1.50003 15V3C1.48843 2.74703 1.57753 2.49976 1.74784 2.31234C1.91814 2.12492 2.15577 2.01261 2.4087 2H10.5907C10.8437 2.01261 11.0814 2.1249 11.2518 2.3123C11.4222 2.4997 11.5114 2.74696 11.5 3V6" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>,
//   'door',
// );

// const edit = createSvgIcon(
//   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M14.06 5.13414L5.29631 13.8979L1 14.9998L2.1013 10.7035L10.8653 1.93944M14.06 5.13414L14.3183 4.87592C14.5322 4.66694 14.7026 4.41763 14.8196 4.14239C14.9366 3.86715 14.9979 3.57145 14.9999 3.27238C15.002 2.97331 14.9447 2.6768 14.8314 2.40001C14.7182 2.12321 14.5511 1.87161 14.34 1.65975C14.1281 1.44871 13.8764 1.28175 13.5996 1.16851C13.3227 1.05528 13.0262 0.998027 12.7271 1.00005C12.428 1.00208 12.1323 1.06334 11.857 1.18031C11.5817 1.29728 11.3323 1.46763 11.1232 1.68153L10.8653 1.93944M14.06 5.13414L10.8653 1.93944" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//   </svg>,
//   'edit',
// );

const sendOutlined = createSvgIcon(
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.32512 12.7218L12.2326 17.938C12.5296 18.3336 13.0321 18.5165 13.5139 18.4042C13.9956 18.292 14.3656 17.9059 14.4571 17.4198L17.1571 3.04003C17.2496 2.553 17.0449 2.05743 16.6357 1.77766C16.2264 1.4979 15.6903 1.48705 15.2701 1.75003L1.40787 10.4155C0.935795 10.7106 0.716271 11.2827 0.869766 11.8179C1.02326 12.353 1.51265 12.7218 2.06937 12.7218H8.32512ZM8.32512 12.7218L6.45012 12.7218V16.6C6.45009 17.0624 6.70584 17.4868 7.11462 17.7028C7.5234 17.9189 8.01815 17.891 8.40012 17.6305L10.7836 16.006L8.32512 12.7218ZM8.32437 12.7218L16.6344 1.77928" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'sendOutlined',
);

const download = createSvgIcon(
  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.75 10.7256L9 14.9756M9 14.9756L13.25 10.7256M9 14.9756V1.47559M1 19.7256H17" stroke="#070243" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'download',
);
const uploader = createSvgIcon(
  <svg width={48} height={48} fill="none">
    <path
      d="M40.5 16.5v-6a3 3 0 00-3-3h-21v-3a3 3 0 00-3-3h-9a3 3 0 00-3 3v29.6a3.4 3.4 0 006.672.876l4.702-16.308a3 3 0 012.884-2.168H43.5a3 3 0 012.9 3.772M16.5 37.5H4.894 16.5z"
      stroke="#070243"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5 34.5h12m-18 0a12 12 0 1024 0 12 12 0 00-24 0zm12-6v12-12z"
      stroke="#070243"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'uploader',
);

const dateRange = createSvgIcon(
  <svg width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.914 24.54v-2.98a0.824 0.824 0 0 0 -1.418 -0.584l-4.65 4.65a0.826 0.826 0 0 0 0 1.184l4.65 4.65a0.834 0.834 0 0 0 1.418 -0.6v-2.984h10v2.984c0 0.75 0.9 1.116 1.416 0.582l4.65 -4.65a0.826 0.826 0 0 0 0 -1.182l-4.65 -4.65a0.832 0.832 0 0 0 -1.416 0.582v3h-10Z" fill="currentColor" />
    <path d="M33.334 5h-1.668v-1.666A1.672 1.672 0 0 0 30 1.666a1.672 1.672 0 0 0 -1.666 1.668V5H11.666v-1.666A1.672 1.672 0 0 0 10 1.666a1.672 1.672 0 0 0 -1.666 1.668V5h-1.668c-1.832 0 -3.332 1.5 -3.332 3.334V35c0 1.834 1.5 3.334 3.332 3.334h26.668c1.832 0 3.332 -1.5 3.332 -3.334V8.334c0 -1.834 -1.5 -3.334 -3.332 -3.334Zm-1.668 30H8.334a1.672 1.672 0 0 1 -1.668 -1.666v-20h26.668v20a1.672 1.672 0 0 1 -1.668 1.666Z" fill="currentColor" />
  </svg>,
  'dateRange',
);

const asterisk = createSvgIcon(
  <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 12V10H21V12H1ZM2.15 5.95L0.85 5.2L1.7 3.7H0V2.2H1.7L0.85 0.75L2.15 0L3 1.45L3.85 0L5.15 0.75L4.3 2.2H6V3.7H4.3L5.15 5.2L3.85 5.95L3 4.45L2.15 5.95ZM10.15 5.95L8.85 5.2L9.7 3.7H8V2.2H9.7L8.85 0.75L10.15 0L11 1.45L11.85 0L13.15 0.75L12.3 2.2H14V3.7H12.3L13.15 5.2L11.85 5.95L11 4.45L10.15 5.95ZM18.15 5.95L16.85 5.2L17.7 3.7H16V2.2H17.7L16.85 0.75L18.15 0L19 1.45L19.85 0L21.15 0.75L20.3 2.2H22V3.7H20.3L21.15 5.2L19.85 5.95L19 4.45L18.15 5.95Z" fill="currentColor" />
  </svg>,
  'asterisk',
);

const edit = pen;

export {
  add,
  arrowBack,
  arrowBackFat,
  arrowForward,
  arrowUp,
  arrowDown,
  arrowRight,
  arrowLeft,
  attachEmail,
  block,
  cancel,
  cancelOutlined,
  close,
  copy,
  door,
  edit,
  filledTrashcan,
  filterList,
  globe,
  mail,
  menu,
  pen,
  print,
  refresh,
  remove,
  save,
  search,
  send,
  sendOutlined,
  trashcan,
  undo,
  uploadFile,
  uploader,
  verticalDots,
  play,
  validate,
  openNewTab,
  download,
  moreTime,
  removeFilter,
  dateRange,
  toggleOn,
  tableChart,
  timeline,
  reload,
  asterisk,
  choices,
  editOutlined,
  warningAmberOutlined,
  arrowRightOutlined,
  arrowLeftOutlined,
  filterAltOffOutlined,
  filterAltOutlined,
  addBoxIcon,
  postAddIcon,
};
